export default __webpack_public_path__ + "static/media/food2.bc7dad8f.jpg";